import React from 'react';

import SvgIcon from './SvgIcon';

const FacebookLogo = props => (
    <SvgIcon {...props}>
        <g id="Page-1">
            <g id="fb_logo-blue_path" transform="translate(0.799442, 0.846086)">
                <path
                    id="Path"
                    className="st0"
                    d="M14.5,7.2c0-3.9-3-7.1-6.9-7.3S0.4,2.6,0,6.4s2.3,7.4,6.1,8V9.3H4.2V7.2h1.8V5.6
					C6,4.8,6.2,4.1,6.8,3.5c0.5-0.5,1.3-0.8,2-0.8c0.5,0,1.1,0.1,1.6,0.1v1.8H9.5C9.2,4.6,8.9,4.8,8.7,5C8.4,5.2,8.3,5.5,8.3,5.8v1.4
					h2L10,9.3H8.3v5.1C11.9,13.9,14.5,10.8,14.5,7.2z"
                />
            </g>
        </g>
    </SvgIcon>
);

FacebookLogo.displayName = 'FacebookLogoIcon';

export default FacebookLogo;
